import { clsx } from 'clsx';
import { NUMBER_OF_GUESTS_FILTER_KEY } from 'components/CruiseSearchWidget/constants';
import { Variant } from 'components/CruiseSearchWidget/types';
import { FilterList } from 'components/FiltersModal/ActiveFilter/filters/FilterList/FilterList';
import { useFiltersModalContext } from 'components/FiltersModalProvider/FiltersModalProvider';
import { useFiltersContext } from 'components/FiltersProvider/FiltersProvider';
import { BaseNumberOfGuestsModal } from 'components/NumberOfGuestsModal/BaseNumberOfGuestsModal/BaseNumberOfGuestsModal';
import { GraphQLFilterTypes } from 'lib/apiClient';
import { useMemo } from 'react';
import styles from './ActiveFilter.css';
import { CustomFilter } from './CustomFilter/CustomFilter';
import { FilterDateRange } from './filters/FilterDateRange/FilterDateRange';
import { FilterGroupList } from './filters/FilterGroupList/FilterGroupList';

const filterTypeToComponent: { [key in GraphQLFilterTypes]?: React.FC<unknown> } = {
	[GraphQLFilterTypes.LIST]: FilterList,
	[GraphQLFilterTypes.GROUP_LIST]: FilterGroupList,
	[GraphQLFilterTypes.NUMBER_RANGE]: FilterList,
	[GraphQLFilterTypes.DATE_RANGE]: FilterDateRange,
};

export interface ActiveFilterProps {
	selectionCount: number;
	variant: Variant;
}

const selectedVariantClass: { [key in Variant]: string } = {
	[Variant.Base]: styles.selectedBase,
	[Variant.Home]: styles.selectedHome,
};

export function ActiveFilter(props: Readonly<ActiveFilterProps>) {
	const { activeFilter, setActiveFilter, filters } = useFiltersContext();
	const { setShowFiltersModal } = useFiltersModalContext();
	const { selectionCount, variant } = props;
	const ActiveFilterComponent = useMemo(() => {
		const filterType = filters.find((filter) => filter.key === activeFilter?.key)?.type as GraphQLFilterTypes;

		if (filterType) {
			return filterTypeToComponent[filterType];
		}

		if (activeFilter?.key === NUMBER_OF_GUESTS_FILTER_KEY) {
			return BaseNumberOfGuestsModal;
		}

		return undefined;
	}, [activeFilter, filters]);

	return (
		<div
			className={clsx(styles.root, {
				[styles.selected]: selectionCount > 0,
				[selectedVariantClass[variant]]: selectionCount > 0,
				[styles.customElement]: Boolean(activeFilter?.customElement),
			})}
		>
			{activeFilter?.customFilterConfig && <CustomFilter />} {/* This only applies for MyOffers filter */}
			{ActiveFilterComponent && <ActiveFilterComponent />}
			{activeFilter?.customElement?.({ setActiveFilter, setShowFiltersModal })} {/* This only applies for MyOffers filter */}
		</div>
	);
}
